<template>
  <div class="cadfm-container-horizontal">
    <!-- <Left  v-show="isVisibleLeft&&!isPlugin" :lang="lang.Left"></Left> -->
    <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left>
    <Middle :routingData="routingData" :lang="lang.Middle"></Middle>
    <Right v-show="isVisibleRight" :lang="lang.Right"></Right>
 </div>
</template>

<script>
import Left from '@/components/LibraryManager/Views/LibraryTable/Left/Left'
import Middle from '@/components/LibraryManager/Views/LibraryTable/Middle/Middle'
import Right from '@/components/LibraryManager/Views/LibraryTable/Right/Right'
import { mapGetters } from 'vuex'

export default {
  name: 'LibraryTable',
  components:{
    Left,
    Middle,
    Right
  },
  props:{
    routingData: Object,
    lang: Object
  },
  computed:{
    ...mapGetters([
        'isPlugin',
       
      ]),
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  mounted () {
    //this.setCategory();
  },
  methods: {
    // setCategory(){
      
    //   if (this.routingData.from == "/Dashboard"){

    //     this.$store.dispatch("setElementCategoryLibrary", this.routingData.parameters[0].category);

    //     for (var i = 0, le = this.$store.getters.categoryMapping.length; i < le; i++){
    //       //console.log(this.$store.getters.elementCategory +"=="+ this.$store.getters.categoryMapping[i].categoryName)
    //       if (this.$store.getters.elementCategory == this.$store.getters.categoryMapping[i].categoryName){
    //         var uid = this.$store.getters.categoryMapping[i].uid;
    //         this.$store.dispatch("selectTreeLibraryItem", uid) 
    //       }else{
    //         //this.$store.dispatch("selectTreeItem", "/All")
    //       }
    //     }
    //   }




    // }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryTable.vue